type ErrorSeverity = 'low' | 'medium' | 'high' | 'critical';

export const customClientErrorHandler = (
  error: any = null,
  severity: ErrorSeverity | null = 'low',
  title: string = 'From customErrorHandler',
  meta: Record<string, any> | null = null
) => {
  let config;
  let appDebug;

  if (import.meta.client) {
    config = useNuxtApp().$config;
    appDebug = useNuxtApp().$config.public.appDebug;
  }

  const isFailedToFetch =
    error?.message &&
    (error.message === 'Failed to fetch' || error.message.includes('Failed to fetch'));

  const errorOptions = {
    error,
    severity,
    title,
    meta,
    environment: config?.public.appEnvironment,
  };

  if (import.meta.client) {
    if (appDebug) {
      consoleLog(title, errorOptions, isFailedToFetch ? 'low' : severity);
    }

    if (!config?.public?.ddClientToken) {
      return false;
    }

    if (!isFailedToFetch) {
      const datadogRum = useNuxtApp().$ddRum;
      if (datadogRum) {
        (datadogRum as any).addError(error, errorOptions);
      }
    }
  }
};
export const customClientWarningHandler = (
  severity: ErrorSeverity | null = 'low',
  title: string = 'From customErrorHandler',
  meta: any = null
) => {
  let config;
  let appDebug;

  if (import.meta.client) {
    config = useNuxtApp().$config;
    appDebug = useNuxtApp().$config.public.appDebug;
  }

  const warningOptions = {
    severity,
    title,
    meta,
    environment: config?.public.appEnvironment,
  };

  if (import.meta.client) {
    if (appDebug) {
      consoleLog(title, warningOptions, severity);
    }

    if (!config?.public?.ddClientToken) {
      return false;
    }
  }
};

export const customClientInfoHandler = (
  title: string = 'From customInfoHandler',
  meta: any = null
) => {
  let config;
  let appDebug;

  if (import.meta.client) {
    config = useNuxtApp().$config;
    appDebug = useNuxtApp().$config.public.appDebug;
  }

  const warningOptions = {
    title,
    meta,
    environment: config?.public.appEnvironment,
  };

  if (import.meta.client) {
    if (appDebug) {
      consoleLog(title, warningOptions, 'info');
    }

    if (!config?.public?.ddClientToken) {
      return false;
    }
  }
};

export const customClientDebugHandler = (
  error: any = null,
  title: string = 'From customDebugHandler',
  meta: any = null
) => {
  let config;
  let appDebug;

  if (import.meta.client) {
    config = useNuxtApp().$config;
    appDebug = useNuxtApp().$config.public.appDebug;
  }

  const debugOptions = {
    error,
    title,
    meta,
    environment: config?.public.appEnvironment,
  };

  if (import.meta.client) {
    if (appDebug) {
      consoleLog(title, debugOptions, 'low');
    }

    if (!config?.public?.ddClientToken) {
      return false;
    }
  }
};

export const customClientErrorHandlerAsync = async (
  error: any = null,
  severity?: ErrorSeverity | null | undefined,
  title: string = 'From customErrorHandler',
  meta: any = null
) => {
  customClientErrorHandler(error, severity, title, meta);
};
export const customServerErrorHandler = (
  error: any = null,
  severity: ErrorSeverity | null = 'low',
  title: string | null = 'From customServerErrorHandler',
  meta: any = null
) => {
  const errorOptions = {
    error: error,
    severity: severity,
    title: title,
    meta: meta,
  };

  consoleLog(title, errorOptions, severity);
};

export const consoleLog = (
  title: string | null,
  errorOptions: Record<string, any>,
  severity: ErrorSeverity | string | null
) => {
  if (severity === 'critical' || severity === 'high') {
    console.error(title, errorOptions);
  } else {
    console.log(title, errorOptions);
  }
};

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('customClientErrorHandler', customClientErrorHandler);
  nuxtApp.provide('customClientWarningHandler', customClientWarningHandler);
  nuxtApp.provide('customClientInfoHandler', customClientInfoHandler);
  nuxtApp.provide('customClientDebugHandler', customClientDebugHandler);
  nuxtApp.provide('customClientErrorHandlerAsync', customClientErrorHandlerAsync);
  nuxtApp.provide('customServerErrorHandler', customServerErrorHandler);

  if (!import.meta.client) return;

  // To log previous route inc case of error - 400 or 500
  const router = useRouter();
  router.beforeEach((to, from) => {
    clearOldCloudRetailEvents();
    sessionStorage.setItem('previousRoute', from.fullPath);
  });
});
